import { Component, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { MediaService } from '../peers/media.service';

import { WbService } from '../wb.service';
import { Modal } from 'ng2-modal';

import { environment } from '../../../environments/environment'
import { ContentParserService } from '../services/content/content-parser.service';
import { Injectable } from '@angular/core';
import {MediaManagerService} from '../services/media/media-manager.service';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { WsService2 } from '../services/ws/ws.service';
import {ButtonComponent} from "../../utils/button/button.component";
import { TranslateService } from 'ng2-translate/ng2-translate';
import { ReplayerService } from '../player/replayer.service';
declare var $;
declare var videojs;
@Component({
  selector: "dskl-content",
  templateUrl: 'content.component.html',

})

export class ContentComponent {

  @ViewChild("contentModal") contentModal: Modal;
@ViewChild("noPluginModal") noPluginModal: Modal;
@ViewChild("split") split: ButtonComponent;
  open() {
    this.content = {}
    
    this.contentModal.open();
    this.getContentsByTeacherHash();
  }
  duration(){
      if (this.player && this.player.duration())
      return this.player.duration();
  }
  ended= false;
  player
  private init() {
    this.player = videojs("player", { inactivityTimeout: 0, language: "bg" });

    this.player.on("play", function (e) {
        _this.ended = false;
      _this.changed("play", _this.player.currentTime());
    })
    this.player.on("pause", function (e) {

      _this.changed("pause", _this.player.currentTime());
      if (_this.player.currentTime()==this.duration()){
          _this.ended = true;
      }
    })
    var _this = this;
    this.player.on("seeked", function (e) {
      _this.changed("seeked", _this.player.currentTime());
    });
  }
  currentTime
  private changed(type, position) {
      console.log("Type is "+type)
    this.currentTime = position
    switch (type){
      case "play": this.playing=true; break;
      case "pause": this.playing=false; break;
    }
  }
 
  initPlayer
  setupPlayer(filename) {
    var self = this;

    if (self.player) {
      try {
        this.player.dispose();
      } catch (error) { console.log(error) }
    }
    this.initPlayer = false;
    setTimeout(function () {
      self.initPlayer = true;
    }, 100);

    setTimeout(function () {
      self.init();
      self.player.src(filename);
      self.player.play();
    }, 200);
  }
  onRecorderFilename(fileName){
      this.contentModal.open();
      console.log("Will create file "+fileName);
      this.createFile(fileName);//todo checks
  }
  constructor(private http: Http, private ws: WsService2, private parserService: ContentParserService, private mediaManagerService: MediaManagerService, private translate: TranslateService, private playerService: ReplayerService) {
      parserService.setCallback(this);
      this.content={}
   }
    private extractData(res: Response) {
        this.ready = true;
        this.connected = true;
        let body = res.json();
        return body || {};
    }
    connected=false
    ready = false;
    post(url, body) {
        url = "content/"+this.ws.getMe() + "/" + url;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, withCredentials: false });
        console.log("WIll post to " + environment.contentsBackendUrl)
        return this.http.post(environment.contentsBackendUrl + url, body, options)
            .map(this.extractData.bind(this)).catch(this.handleError.bind(this))

    }
    private handleError(error: Response | any) {
        this.connected = false;
        this.ready = true;
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Promise.reject(errMsg);
    }
    isFileSelected(){
        return this.playerService.getRecordContainerId()!=null;
    }
    content;
    getContentsByTeacherHash() {
        var self = this;
        console.log("Will get contents")
        this.post("", { name: name }).subscribe(r => {

            if (r && r[0]) {
                console.log("Got ", r);
                self.post(r[0].id, null).subscribe(c => {
                    
                    self.content = c;
                });
            }
        });
    }
    createContent(name) {
        var self = this;
        this.post("create", { name: name }).subscribe(r => {
            self.getContentsByTeacherHash();
        });
    }
    createFile(fileName) {
         var self = this;
        this.post(this.content["id"]+"/create", {fileName: fileName}).subscribe(r=>
        {
             self.getContentsByTeacherHash();
        })
    }
    rename(value, id){
         var self = this;
         
         var fid= this.content["workingFiles"][id].id;
        this.post(this.content["id"]+"/"+fid+"/rename", {name: value}).subscribe(r=>{
                self.getContentsByTeacherHash();
               
        });
    }
    deleteFile(id) {
        var self = this;
        var fid= this.content["workingFiles"][id].id;
        this.post(this.content["id"]+"/"+fid+"/delete", null).subscribe(r=>{
                self.getContentsByTeacherHash();
        });
    }
    undeleteFile(id) {
        var self = this;
     
        this.post(this.content["id"]+"/"+id+"/undelete", null).subscribe(r=>{
                self.getContentsByTeacherHash();
        });
    }
     addAtEnd(id){
        var self = this;
        this.post(this.content["id"]+"/"+this.playerService.getRecordContainerId()+"/append/"+id, null).subscribe(r=>{
            console.log("Got ", r);
            self.getContentsByTeacherHash();
        });
  }
    splitFile() {
        var self = this;
        this.split.loading();
        this.post(this.content["id"]+"/"+this.playerService.getRecordContainerId()+"/split", {time: +this.currentTime}).subscribe(r=>{
            console.log("Got ", r);
            self.split.reset();
            self.getContentsByTeacherHash();
        }, error=>{
            self.split.reset();
        });
    }
    concatFiles(fileId1, fileId2) {

    }
    isPlaying(){
        return this.playerService.isPlaying();
    }
    playing = false;
  
    openShareScreen(){
 
  var _this = this;
 
  this.mediaManagerService.shareScreen(function(hasPlugin){
    if (!hasPlugin){
      _this.noPluginModal.open();
    }else{
     // _this.screenShareNotAvailable.open();
    }
  })
  }
  openPluginPage(){
    this.translate.get('SHARE_SCREEN.PLUGIN_URL').subscribe((url: string) => { 
      window.open(url, "_blank").focus();
    });
    
  }
}


// WEBPACK FOOTER //
// /app/src/app/wb/tools/content.component.ts